export const downloadFileFromFetchRsp = async (response: Response) => {
  if (response.ok) {
    let blob = await response.blob();
    let url = window.URL.createObjectURL(blob);
    let a = document.createElement('a');
    a.href = url;
    a.download = 'filename.xlsx'; // TODO - get the filename from the API response
    document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
    a.click();
    a.remove();
  } else {
    //TODO - error response.status
  }
};
